export enum ScheduleFrequencyType {
    ONE_TIME = 'one-time',
    MONTHLY = 'monthly',
    QUATERLY = 'quaterly',
    SEMIANNUAL = 'semi-annual',
    ANNUAL = 'annual'
}
